type MinicartWrapperContainerProps = { children: React.ReactNode };

const MinicartWrapperContainer = ({ children }: MinicartWrapperContainerProps) => {
	return (
		<aside className={`vtex-minicart-2-x-minicartWrapperContainer relative fr flex items-center`}>{children}</aside>
	);
};

export default MinicartWrapperContainer;
